require('./brokerMiFID2DisapprovedTestDisclaimer.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');

// @components
const { ContentBox } = require('commonsComponents/contentBox');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @helpers
const { FormattedText } = require('core/i18n').i18n;
const { formatDate } = require('utilities/dateHelper');

// @constants
const { DATE_FORMAT_SLASHED_ES, DATE_FORMAT } = require('constants/index');

class BrokerMiFID2DisapprovedTestDisclaimer extends React.Component {

    render() {
        const { immBrokerConsultMiFID } = this.props;

        const date = immBrokerConsultMiFID.get('fecha') && (
            <span>
                {formatDate(
                    moment(immBrokerConsultMiFID.get('fecha'), DATE_FORMAT_SLASHED_ES),
                    DATE_FORMAT
                )}
            </span>
        );
        return(
            <ContentBox>
                <div className="broker-disaproved-test-diclaimer__content">
                    <p className="broker-disaproved-test-diclaimer__paragraph">
                        <FormattedTextWithComponents
                            value="broker-convenienceMifidDisapproveTestContent1" 
                            injectedComponents ={[
                                date
                            ]}
                        />
                    </p>
                    <p className="broker-disaproved-test-diclaimer__paragraph">
                        <FormattedText value="broker-convenienceMifidDisapproveTestContent2" />
                    </p>
                </div>
                <footer className="broker-disaproved-test-diclaimer__footer text-right">
                    <OKButton
                        modifier="secondary"
                        to="/myprofile/broker/general"
                    >
                        <FormattedText value="broker-convenienceMifidDisapproveTestButtonText" />
                    </OKButton>
                </footer>
            </ContentBox>
        );
    }
}

BrokerMiFID2DisapprovedTestDisclaimer.propTypes = {
    immBrokerConsultMiFID: PropTypes.object.isRequired
}

module.exports = BrokerMiFID2DisapprovedTestDisclaimer;